import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ReactComponent as IconCommonError } from '../../assets/iconCommonError.svg';
import './ErrorMsgBox.scss';

const variants = {
  initial: { y: '50%', opacity: 0 },
  animate: { y: 0, opacity: 1, transition: { ease: 'linear', duration: 0.1 } },
  exit: {
    y: '100%',
    opacity: 0,
    transition: { ease: 'linear', duration: 0.1 },
  },
};

const ErrorMsgBox = ({ visible = false, children }) => {
  return (
    <div className="ErrorMsgBox">
      <AnimatePresence exitBeforeEnter>
        {visible && (
          <motion.div
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <IconCommonError />
            <div className="error font_regular text_brightOrange">
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ErrorMsgBox;
